import { render, staticRenderFns } from "./addwelfareOperation.vue?vue&type=template&id=26fcede0&scoped=true&"
import script from "./addwelfareOperation.vue?vue&type=script&lang=js&"
export * from "./addwelfareOperation.vue?vue&type=script&lang=js&"
import style0 from "./addwelfareOperation.vue?vue&type=style&index=0&id=26fcede0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fcede0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26fcede0')) {
      api.createRecord('26fcede0', component.options)
    } else {
      api.reload('26fcede0', component.options)
    }
    module.hot.accept("./addwelfareOperation.vue?vue&type=template&id=26fcede0&scoped=true&", function () {
      api.rerender('26fcede0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/welfareOperation/components/addwelfareOperation.vue"
export default component.exports